import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import * as SRC from 'modules/styled';
import RouteLayout from 'containers/RouteLayout';
import asyncComponent from 'components/AsyncComponent';
import GoogleAnalytics from 'components/GoogleAnalytics';

const CompaniesPage = asyncComponent(() => import('pages/CompaniesPage'));
const LoginPage = asyncComponent(() => import('pages/LoginPage'));
const LoadingPage = asyncComponent(() => import('pages/LoadingPage'));
const ReportsPage = asyncComponent(() => import('pages/ReportsPage'));
const ReportsDetail = asyncComponent(() => import('pages/ReportsDetail'));
const FeedbacksPage = asyncComponent(() => import('pages/FeedbacksPage'));
const FeedbackDetail = asyncComponent(() => import('pages/FeedbackDetail'));
const GalleryPage = asyncComponent(() => import('pages/GalleryPage'));
const ExportsPage = asyncComponent(() => import('pages/ExportsPage'));
const InsightsPage = asyncComponent(() => import('pages/InsightsPage'));
const DemoLoginPage = asyncComponent(() => import('pages/DemoLoginPage'));

export default (
  <Router>
    <SRC.MainScreen>
      <Switch>
        <Route exact path="/demo" title="Demo" component={DemoLoginPage} />
        <Route exact path="/" component={LoginPage} />
        <RouteLayout exact path="/login" title="" component={LoadingPage} />
        <RouteLayout exact path="/companies" title="Companies" component={CompaniesPage} />
        <RouteLayout exact path="/reports" title="Reports" component={ReportsPage} />
        <RouteLayout path="/reports/:id" component={ReportsDetail} />
        <RouteLayout exact path="/feedbacks" title="Feedbacks" component={FeedbacksPage} />
        <RouteLayout path="/feedbacks/:id" component={FeedbackDetail} />
        <RouteLayout path="/gallery" title="Gallery" component={GalleryPage} />
        <RouteLayout exact path="/exports" title="Exports" component={ExportsPage} />
        <RouteLayout exact path="/insights" title="Insights" component={InsightsPage} />
      </Switch>
      <GoogleAnalytics />
    </SRC.MainScreen>
  </Router>
);
